import React, { Component } from "react";
import { Card, CardHeader, Col } from "reactstrap";
import Swal from "sweetalert2";
import Image3DViewer from "../Image3DViewer";
import Axios from "axios";
import { configuration } from "../../appConfig";
import { connect } from "react-redux";
import $ from "jquery";

// Axios.defaults.headers.common['X-Auth-Token'] = localStorage.getItem('partnerId');

const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});

class vehicleDentInfo3DNew extends Component {
  state = {
    words: {},
    lang: "En",
    selectedFile: "",
    order: {
      vinNumber: "",
      orderNumber: Math.round(Math.random() * 100000000),
      issuedOn: new Date(),
    },
    partDetails: null,
    twoDView: true,
    vinNumber: null,
    vinfolderList: [],
    showTwoDView: true,
    selectedPartInfo: [],
    scanresult: [],
    autoRotate: false,
    Image360URL: "https://theta360.com/s/rSWxqp2kQpAFF1hbTJZc4a4WG?view=embed",
    iframeSource: "https://theta360.com/s/rSWxqp2kQpAFF1hbTJZc4a4WG?view=embed",
  };
  componentDidMount() {
    // require("./360_controller");
    const selectedFile = localStorage.getItem("selectedFile");
    this.setState({ vinNumber: selectedFile });

    this._get360ImageLink();

    this.vinFolderList();
    this.getLang();
    this._getImages();

    // this.removeElement("#iframe");
  }

  _get360ImageLink = () => {
    const vinNumber = localStorage.getItem("selectedFile");
    const partnerId = localStorage.getItem("partnerId");
    Axios.get(configuration.get360ImageLink, {
      params: {
        vin: vinNumber,
        partnerId,
      },
    })
      .then((res) => {
        if (res.data["360_image_url"]) {
          this.setState({
            Image360URL: res.data["360_image_url"],
            iframeSource: res.data["360_image_url"],
          });
        }
      })
      .catch((err) => console.log(err));
  };

  _onLoadAndUpdate3dViewClick = () => {
    const { Image360URL } = this.state;
    let url_specific_regex = /(http|https):\/\/theta360.com\/s\/.*/;

    if (Image360URL.match(url_specific_regex)) {
      const _containsQueryString = (
        url = "",
        parameter_to_search = "",
        value_parameter = ""
      ) => {
        if (url) {
          if (
            url.indexOf("?" + parameter_to_search + "=" + value_parameter) != -1
          )
            return true;
          else if (
            url.indexOf("&" + parameter_to_search + "=" + value_parameter) != -1
          )
            return true;

          return false;
        }
      };

      let iframe_source = "";
      if (_containsQueryString(Image360URL, "view", "embed")) {
        iframe_source = Image360URL;
      } else {
        iframe_source = iframe_source.split("?")[0] + "?view=embed";
      }

      const partnerId = localStorage.getItem("partnerId");
      const selectedFile = localStorage.getItem("selectedFile");
      Axios.post(configuration.update360ImageLink, {
        vin: selectedFile,
        partnerId: partnerId,
        image_url: iframe_source,
      })
        .then((res) => {
          this.setState({
            iframeSource: iframe_source,
            Image360URL: iframe_source,
          });
        })
        .catch((err) => {
        });
    } else if (Image360URL) {
      alert("Invalid url");
    }
  };

  removeElement = (element_id) => {
    // Removes an element from the document.
    // var element = document.getElementById(element_id);
    $(element_id).contents().find("span").remove();
    var iframe = $(element_id).contents().contents()[0];
    iframe.setAttribute("id", "iframe_doc");
    var iframe_body = iframe.contentDocument; //contentWindow is used to get the document of an iframe
    var iframe_doc = $("#iframe_doc").contents().find(".main_contents");
    // var document = iframe[0];

    // iframe = iframe.contents();
    // $();
    // document.getElemen
    // element.remove();
  };

  _getImages = async () => {
    const selectedFile = localStorage.getItem("selectedFile");
    const partnerId = localStorage.getItem("partnerId");
    await Axios.get(
      configuration.getImages +
        "?vin=" +
        selectedFile +
        "&partnerId=" +
        partnerId
    )
      .then((res) => {
      })
      .catch((err) => {
      });
  };

  getLang = () => {
    const base_url = window.location.origin;
    Axios.get(`${base_url}/lang.json`).then((res) => {
      this.setState({ words: res.data, lang: localStorage.getItem("lang") });
    });
  };
  lang = (word) => {
    const { lang, words } = this.state;
    return words[word] ? words[word][lang] : word;
  };
  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.lang !== prevState.lang) {
      return { lang: nextProps.lang };
    } else return null;
  }
  handleChange = (e) => {
    this.setState({
      customerInfo: {
        ...this.state.customerInfo,
        [e.target.name]: e.target.value,
      },
    });
  };
  customerInfo = async () => {
    const partnerId = localStorage.getItem("partnerId");
    const vin = localStorage.getItem("selectedFile");
    if (partnerId) {
      const res = await Axios.get(
        configuration.getCustomerInfo +
          "?partnerId=" +
          partnerId +
          "&vin=" +
          vin
      );
      if (res.data.length) {
        this.setState({ customerInfo: res.data[0] });
      }
    } else {
    }
  };
  vinFolderList = async () => {
    const partnerId = localStorage.getItem("partnerId");
    const selectedFile = localStorage.getItem("selectedFile");
    if (partnerId) {
      const response = await Axios.get(
        configuration.resultTxt +
          "?vin=" +
          selectedFile +
          "&partnerId=" +
          partnerId
      );

      if (response.data[0] && response.data[0].resultTXT) {
        this.setState({
          vinfolderList: response.data,
          scanresult: response.data[0].resultTXT,
        });
      } else {
        // alert('Data not available.')
      }
    } else {
      this.props.history.push("/login");
    }
  };

  selectFile = (e) => {
    localStorage.setItem("selectedFile", e.target.value);
    this.setState({ selectedFile: e.target.value });
  };
  showDummyData = () => {
    this.customerInfo();
  };

  SizeDropdown = (size, index) => {
    const arr = [0, 10, 20, 30, 40, 50, 60, 70, 80];
    return (
      <select value={size} onChange={(e) => this.change(e.target.value, index)}>
        {arr.map((row, i) => (
          <option key={i}>{row}</option>
        ))}
      </select>
    );
  };
  change = (val, index) => {
    const { scanresult } =
      this.state.vinfolderList.length && this.state.vinfolderList[0].resultTXT;

    scanresult[index].size = val;
    this.setState({ scanresult });
    const result = window.confirm("Are you sure want to change Size?");
    if (result) {
      const url = configuration.Update_ResultTxt;
      let payload = {
        scanresult: scanresult,
        partnerId: localStorage.getItem("partnerId"),
        vin: localStorage.getItem("selectedFile"),
      };
      Axios.post(url, payload).then((res) => {
        Toast.fire({
          type: "success",
          title: "Data saved successfully",
        });
      });
    }
  };

  showData = (partName) => {
    this.props.history.push("PartDetails/" + partName, { part: partName });
  };

  _onInputHandleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  render() {
    const { orderNumber } = this.state.order;

    const scanResult =
      this.state.vinfolderList.length && this.state.vinfolderList[0];
    scanResult.resultTXT && scanResult.resultTXT.scanresult &&
      scanResult.resultTXT.scanresult.filter((row) => {
        if (row.size) {
          let size = row.size - (row.size % 10);
          return (row.size = row.size % 10 >= 5 ? size + 10 : size);
        } else {
          return row;
        }
      });

    return (
      <>
        <div className="animated fadeIn">
          <Col xs="12" sm="12">
            <Card className="m-0">
              <CardHeader>
                <small className="pull-right rightLbl"></small>
                <small>
                  {" "}
                  VIN Number : {localStorage.getItem("selectedFile")}
                </small>
              </CardHeader>

              <div className="m-3 card" style={{ height: "90vh" }}>
                <div className="row">
                  <div className="col-lg-3"></div>
                  <div className="col-lg-6 text-center">
                    <div className="input-group">
                      <input
                        className="form-control mr-3 rounded"
                        id="360ImageURL"
                        name="Image360URL"
                        value={this.state.Image360URL}
                        placeholder="360 Degree Image URL"
                        onChange={this._onInputHandleChange}
                      />
                      <button
                        className="btn btn-primary"
                        onClick={this._onLoadAndUpdate3dViewClick}
                      >
                        Load &amp; Update 3D View
                      </button>
                    </div>

                    <div className="rounded-top card-header mt-3 d-flex justify-content-center align-items-center">
                      <strong>{this.lang("3D View")}</strong>
                    </div>
                    <div id="iframe">
                      <iframe
                        src={this.state.iframeSource}
                        style={{
                          height: "75vh",
                          width: "100%",
                          border: "none",
                        }}
                        className="rounded-bottom"
                        title="360 Viewer"
                      ></iframe>
                    </div>
                  </div>
                  <div className="col-lg-3"></div>
                </div>
              </div>
            </Card>
          </Col>
        </div>
      </>
    );
  }
}

const mapStateToProps = (props) => {
  return {
    lang: props.lang,
  };
};
export default connect(mapStateToProps)(vehicleDentInfo3DNew);
